export const BASIC_IMAGE_GQL = `
  documentId
  formats
  url
`;
